import React from 'react';

function ThankYou() {
    return (
        <div className='footer-logo'>
            <img
                src="./Thank-You-page.svg"
                alt="Thank You"
                style={{ width: '1400px', height: '400px' }} // Adjust the size as needed
            />
        </div>
    );
}

export default ThankYou;
